/**
 * @description Generic text component
 * <Text
 *   color="#000"
 *   size="10px"
 *   weight="400"
 *   text="Text to show"
 *   padding="0 0 0 0"
 *   margin="0 0 0 0"
 *   align="left"
 *   inlineBlock
 * />
 * padding y margin pueden tener los mismos valores validos de css
 * @author Camilo Ramirez
 */

import React from 'react';
import PropTypes from 'prop-types';
import TextContainer from './styles/TextStyled';

const Text = ({
  color,
  size,
  weight,
  text,
  padding,
  margin,
  align,
  lineHeight,
  inlineBlock,
}) => (
  <TextContainer
    color={color}
    size={size}
    weight={weight}
    padding={padding}
    margin={margin}
    align={align}
    lineHeight={lineHeight}
    inlineBlock={inlineBlock}
  >
    {text}
  </TextContainer>
);

Text.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  weight: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  padding: PropTypes.string,
  margin: PropTypes.string,
  align: PropTypes.string,
  lineHeight: PropTypes.string,
  inlineBlock: PropTypes.bool,
};

Text.defaultProps = {
  padding: '0',
  margin: '0',
  align: 'left',
  lineHeight: 'normal',
  inlineBlock: false,
};

export default Text;
